import { render, staticRenderFns } from "./WhoWeAre2.vue?vue&type=template&id=6aa228ae&scoped=true&"
import script from "./WhoWeAre2.vue?vue&type=script&lang=js&"
export * from "./WhoWeAre2.vue?vue&type=script&lang=js&"
import style0 from "./WhoWeAre2.vue?vue&type=style&index=0&id=6aa228ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa228ae",
  null
  
)

export default component.exports